import React from "react";
import { useParams } from "react-router-dom";
import Page from "../../common/layout/Page";
import Loader from "../../common/Loader";
import ACContainer from "./ACContainer";
import AUTOContainer from "./AUTOContainer";
import MRPContainer from "./MRPContainer";
import useForms from "./useForms";
import useAutoRequests from "./useAutoRequests";
import CYBERContainer from "./CYBERContainer";
import RCPROContainer from "./RCPROContainer";
import useEspaceActif, { ESPACES } from "../../../hooks/useEspaceActif/useEspaceActif";

const Forms = () => {
  const { espace } = useEspaceActif();
  const estEspaceParticulier = espace === ESPACES.PARTICULIER;
  // Chaque espace ne charge et n'affiche que ses demandes (PER-2209/PER-2416).
  const { hasAC, hasMRP, hasCYBER, hasRCPRO, clients, isLoading } = useForms(!estEspaceParticulier);
  const { hasAUTO, autoRequests, isLoadingAuto } = useAutoRequests(estEspaceParticulier);

  // fix au passage : les hasXXX sont des booléens, l'ancien `=== 0` ne matchait jamais
  const hasNoForms = !hasAC && !hasMRP && !hasCYBER && !hasRCPRO && !hasAUTO;

  return (
    <Page margin="mt-5" back={"/"} backText="Retour">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="mb-4">
            <p className="custom-p ">
              {estEspaceParticulier ? (
                <>
                  <strong>Suivez vos demandes</strong> d'assurance et{" "}
                  <strong>téléchargez vos devis</strong>.
                </>
              ) : (
                <>
                  <strong>Visualisez</strong>, <strong>téléchargez</strong> et/ou{" "}
                  <strong>modifiez</strong> vos demandes d'assurance.
                </>
              )}
            </p>
            {hasNoForms && !isLoadingAuto && (
              <p className="custom-p text-center">
                <strong>
                  Vous n'avez aucune demande en cours pour le moment.
                </strong>
              </p>
            )}
          </div>
          {estEspaceParticulier && !isLoadingAuto && hasAUTO && (
            <AUTOContainer autoRequests={autoRequests} />
          )}
          {!estEspaceParticulier && hasMRP && <MRPContainer MRPClients={clients.MRP} />}
          {!estEspaceParticulier && hasAC && <ACContainer ACClients={clients.AC} />}
          {!estEspaceParticulier && hasCYBER && <CYBERContainer CYBERClients={clients.CYBER} />}
          {!estEspaceParticulier && hasRCPRO && <RCPROContainer RCPROClients={clients.RCPRO} />}
          {!estEspaceParticulier && (
            <div className="d-center">
              <a
                className="btn btn-primary text-white cursor-pointer"
                href={process.env.REACT_APP_WEB_FORM_URL}
                target="_blank"
              >
                Découvrir les assurances disponibles pour mon entreprise
              </a>
            </div>
          )}
        </>
      )}
    </Page>
  );
};

export default Forms;
